import Vuetify from '@/plugins/vuetify';

export default {
  getListaPrevisaoDemandaDomestica(state) {
    return state.listaPrevisaDemandaDomestica;
  },
  getHeaders(state) {
    return state.headers.map((coluna) => ({
      ...coluna,
      value: coluna.value,
      text: Vuetify.framework.lang.t(`$vuetify.${coluna.i18n}`),
    }));
  },
  getFiltros(state) {
    return state.filtros;
  },
};
